export class Banknotes {
    static oneDollarCount: number = 1;
    static twoDollarCount: number = 2;
    static fiveDollarCount: number = 5;
    static tenDollarCount: number = 10;
    static twentyDollarCount: number = 20;
    static fiftyDollarCount: number = 50;
    static oneHundredDollarsCount: number = 100;
}
